/**
 *
 * OCRTextPageRegionLine
 *
 */

import * as React from 'react';
import clsx from 'clsx';
import { useMemo } from 'react';
import { OCRLine, ocrBoundingBoxToPosition } from 'lib/api/ocrResult';

// parts
import { OCRTextPageRegionLineWord } from './OCRTextPageRegionLineWord';

// decorate
import { decorate, Decorate } from './decorate';

interface OCRTextPageRegionLineProps {
  scale: number;
  line: OCRLine;
  outlined: boolean;
  visibleWords: boolean;
  outlinedWords: boolean;
  disableWordsText: boolean;
  parentTop: number;
  parentLeft: number;
}

const OCRTextPageRegionLine: React.FC<OCRTextPageRegionLineProps & Decorate> = (props) => {
  const {
    classes,
    scale,
    line,
    outlined,
    visibleWords,
    outlinedWords,
    disableWordsText,
    parentTop,
    parentLeft,
  } = props;

  const { top, left, width, height } = useMemo(() => ocrBoundingBoxToPosition(line.BoundingBox), [
    line.BoundingBox.Rectangle,
  ]);

  return (
    <div
      className={clsx(classes.root, outlined && classes.outlined)}
      style={{
        top: (top - parentTop) * scale,
        left: (left - parentLeft) * scale,
        width: width * scale,
        height: height * scale,
      }}
    >
      {line.Words.map((word, index) => (
        <OCRTextPageRegionLineWord
          key={`word-${index.toString()}`}
          scale={scale}
          word={word}
          visible={visibleWords}
          outlined={outlinedWords}
          disableText={disableWordsText}
          parentTop={top}
          parentLeft={left}
        />
      ))}
    </div>
  );
};

const ComposedOCRTextPageRegionLine = decorate(OCRTextPageRegionLine);
export { ComposedOCRTextPageRegionLine as OCRTextPageRegionLine };
